module.exports = __webpack_public_path__ + "img/law2-m@2.ab9c4ba3.webp";